import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET `/crm/sales-order/{id}/sn-candidates`。
 * 僅 DRAFT；回 `lines[].mtrs[]`（requiredQty／selectedMtrSnIds／candidates）。查詢不占用 SN。
 */
export async function fetchSalesOrderSnCandidates(id) {
  const { data: raw } = await request.get(
    `/crm/sales-order/${id}/sn-candidates`,
  );
  return parseVer4DetailResponse(raw);
}
